
<template>
  <div class="content">
    <div class="imgbox">
      <!-- <img src="../assets/about/banner01.png" alt="" /> -->
      <div class="banner_text">
        <span></span>
        <!-- <span>对物理世界的全面信息感知</span> -->
        <span>赋能政企数字化转型和智能化运营</span>
        <span
          >科技创新驱动，自主研发支撑，从硬件设备到软件系统，从顶层规划设计到基础设施建设，为客户提供优质的软硬件产品和专业配套服务。</span
        >
        <div class="banner_btn">
          <!-- <button @click="gotoAbout()">关于我们 ></button>
          <button @click="gotoContact()">联系我们 ></button> -->
        </div>
      </div>

      <!-- <div class="Anchor_point">
        <a href="#hardware" class="item">
          <img src="../assets/icon/1.png" alt="" />
          <span>硬件产品</span>
        </a>
        <a href="#software" class="item">
          <img src="../assets/icon/1.png" alt="" />
          <span>软件产品</span>
        </a>
        <a href="#hardware_customization" class="item">
          <img src="../assets/icon/1.png" alt="" />
          <span>硬件定制开发</span>
        </a>
        <a href="#software_customization" class="item">
          <img src="../assets/icon/1.png" alt="" />
          <span>软件定制开发</span>
        </a>
      </div> -->
    </div>

    <div :class="show1 ? 'header1' : ''"></div>
    <div class="header" :class="show ? 'header' : 'issFixed'">
      <!-- <a href="#hardware" class="item"> -->
      <div class="item" @click="returnTop()">
        <img src="../assets/icon/Hartware1.jpg" alt="硬件产品图标" />
        <span>硬件产品</span>
      </div>
      <!-- </a> -->
      <!-- <a href="#software" class="item"> -->
      <div class="item" @click="returnTop1()">
        <img src="../assets/icon/Hartware2.jpg" alt="软件产品图标" />
        <span>软件产品</span>
      </div>
      <!-- </a> -->
      <!-- <a href="#hardware_customization" class="item"> -->
      <div class="item" @click="returnTop2()">
        <img src="../assets/icon/Hartware3.jpg" alt="硬件定制研发图标" />
        <span>硬件定制研发</span>
      </div>
      <!-- </a> -->
      <!-- <a href="#software_customization" class="item"> -->
      <div class="item" @click="returnTop3()">
        <img src="../assets/icon/Hartware4.jpg" alt="软件定制开发图标" />
        <span>软件定制开发</span>
      </div>
      <!-- </a> -->
    </div>

    <!-- 硬件产品 -->
    <div ref="header" class="hardware" id="hardware" style="w">
      <div class="title" style="margin-left: -100px">
        <span></span>
        <h2>硬件产品</h2>
      </div>
      <div class="infor_data">
        <div class="Rotation_box" style="margin-left: -80px">
          <!-- <img
            class="prev"
            src="../assets/icon/left.png"
            alt=""
            @click="prevClick1"
          />
          <img
            class="next"
            src="../assets/icon/right.png"
            alt=""
            @click="nextClick1"
          /> -->
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in HardwareList"
              :key="index"
            >
              <div class="devImg">
                <img :src="item.devImg" alt="硬件产品图片" />
              </div>
              <div class="text">
                <p>{{ item.devName }}</p>
                <span @click="gotoDetail(item)">详细参数</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 软件产品 -->
    <div class="software" id="software">
      <div class="title">
        <span></span>
        <h2>软件产品</h2>
      </div>
      <div class="infor_data">
        <div class="tabs">
          <div
            class="tabs_item"
            :class="Sindex == index ? 'active' : ''"
            v-for="(item, index) in softwareTabs"
            :key="index"
            @click="TabsClick(index)"
          >
            <img :src="Sindex == index ? item.img : item.imgURL" alt="软件产品切换图标" />
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="tabs_content">
          <div class="item_content" v-if="Sindex == 0">
            <div class="item" v-for="(item, index) in Software" :key="index">
              <!-- <img @click="gotoSoftware(item)" :src="item.proIcon" alt="" /> -->

              <a :href="`#/SoftwareDetail/${item.proId}/1`">
                <img :src="item.proIcon" alt="智慧水利软件产品图标" />
              </a>
              <span>{{ item.proName }}</span>
            </div>
            <!-- <div class="item">
              <img src="../assets/home/water-conservancy02.png" alt="" />
              <span>闸泵远程控制系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/water-conservancy03.png" alt="" />
              <span>自动水位监测系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/water-conservancy04.png" alt="" />
              <span>城市防汛监管系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/water-conservancy05.png" alt="" />
              <span>雨晴自动遥测系统</span>
            </div> -->
          </div>
          <div class="item_content" v-if="Sindex == 1">
            <div class="item" v-for="(item, index) in Software" :key="index">
              <!-- <img @click="gotoSoftware1(item)" :src="item.proIcon" alt="" /> -->
              <a :href="`#/SoftwareDetail/${item.proId}/1`">
                <img :src="item.proIcon" alt="智慧城管软件产品图标" />
              </a>
              <span>{{ item.proName }}</span>
            </div>
            <!-- <div class="item">
              <img src="../assets/home/Urban-management01.png" alt="" />
              <span>智慧水务综合管理平台</span>
            </div>
            <div class="item">
              <img src="../assets/home/Urban-management02.png" alt="" />
              <span>闸泵远程控制系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/Urban-management03.png" alt="" />
              <span>自动水位监测系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/Urban-management04.png" alt="" />
              <span>城市防汛监管系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/Urban-management05.png" alt="" />
              <span>雨晴自动遥测系统</span>
            </div> -->
          </div>
          <div class="item_content" v-if="Sindex == 2">
            <div class="item" v-for="(item, index) in Software" :key="index">
              <!-- <img @click="gotoSoftware2(item)" :src="item.proIcon" alt="" /> -->
              <a :href="`#/SoftwareDetail/${item.proId}/1`">
                <img :src="item.proIcon" alt="智慧农业软件产品图标" />
              </a>
              <span>{{ item.proName }}</span>
            </div>
            <!-- <div class="item">
              <img src="../assets/home/Agriculture01.png" alt="" />
              <span>智慧水务综合管理平台</span>
            </div>
            <div class="item">
              <img src="../assets/home/Agriculture02.png" alt="" />
              <span>闸泵远程控制系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/Agriculture03.png" alt="" />
              <span>自动水位监测系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/Agriculture04.png" alt="" />
              <span>城市防汛监管系统</span>
            </div>
            <div class="item">
              <img src="../assets/home/Agriculture05.png" alt="" />
              <span>雨晴自动遥测系统</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 硬件定制开发 -->
    <div class="hardware_customization" id="hardware_customization">
      <div class="title">
        <h2 style="margin-left:0px;margin-bottom:5px">硬件定制研发</h2>
        <p>秉承匠心精神，打造产品极致体验</p>
        <p>
          从需求解读到交付使用，从设计开发到测试验收，每一个环节都承载这我们的智慧、经验和努力。
        </p>
        <!-- <button @click="gotoContact()">联系我们 ></button> -->
         <button><a href="#/contact">联系我们 ></a></button>
        <img src="../assets/product/hardware.jpg" alt="硬件定制研发图片" />
      </div>
      <div class="service_content">
        <div class="left_img">
          <img src="../assets/product/service_content_img.jpg" alt="服务内容图片" />
        </div>
        <div class="right_text">
         <h2 style="font-size:24px;margin-left:0px">服务内容</h2>
          <div class="list">
            <div class="left">
              <div class="item">
                <span>01</span>
                <span>硬件电路设计</span>
              </div>
              <div class="item">
                <span>02</span>
                <span>PCB布板</span>
              </div>
              <div class="item">
                <span>03</span>
                <span>物料清单</span>
              </div>
              <div class="item">
                <span>04</span>
                <span>SMT加工</span>
              </div>
              <div class="item">
                <span>05</span>
                <span>嵌入式编程</span>
              </div>
            </div>
            <div class="right">
              <div class="item">
                <span>06</span>
                <span>外形效果设计</span>
              </div>
              <div class="item">
                <span>07</span>
                <span>材料评估选择</span>
              </div>
              <div class="item">
                <span>08</span>
                <span>结构布局设计</span>
              </div>
              <div class="item">
                <span>09</span>
                <span>加工手板</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="service_process">
        <div class="process_title">
          <h2 style="font-size:28px;margin-left:0px">服务流程</h2>
        </div>
        <div class="process_box">
          <div class="line">
            <span
              :style="{
                width:
                  HPindex == 0
                    ? '10%'
                    : HPindex == 1
                    ? '30%'
                    : HPindex == 2
                    ? '50%'
                    : HPindex == 3
                    ? '70%'
                    : '100%',
              }"
            ></span>
          </div>
          <div
            class="process_item"
            v-for="(item, index) in HprocessList"
            :key="index"
          >
            <div
              class="item_list"
              :style="{ opacity: HPindex >= index ? '1' : '0' }"
            >
              <span v-for="(ite, idx) in item.list" :key="idx">{{ ite }}</span>
            </div>
            <div class="node">
              <span></span>
            </div>
            <div
              class="list"
              :class="HPindex >= index ? 'active' : ''"
              @click="processItemClick(index)"
            >
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="Networking">
        <div class="Networking_title">
          <h2 style="font-size:28px;margin-left:0px">联网方式</h2>
        </div>
        <div class="Rotation_box">
          <div class="Rotation">
            <div class="list" style="margin-top: 0px">
              <ul>
                <li><img src="../assets/product/bluetooth.jpg" alt="联网方式图片" /></li>
                <li><img src="../assets/product/wifi.jpg" alt="联网方式图片" /></li>
                <li><img src="../assets/product/lora.jpg" alt="联网方式图片" /></li>
                <li><img src="../assets/product/4G.jpg" alt="联网方式图片" /></li>
                <li><img src="../assets/product/zigbee.jpg" alt="联网方式图片" /></li>
                <li><img src="../assets/product/NFC.jpg" alt="联网方式图片" /></li>
                <li><img src="../assets/product/NB-loT.jpg" alt="联网方式图片" /></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 说明 -->
      <div class="explain">
        <div class="left_text">
          <h2
            class="title1"
            style="font-size: 28px; font-weight: 600; color: #2c3e50"
          >
            售后服务
          </h2>
          <div class="left_title">
            <img src="../assets/product/explain_1.jpg" alt="交付资料图片" />
            <span>设计完成交付资料</span>
          </div>
          <div class="item">
            <span>01</span>
            <span>硬件资料：</span>
            <span>原理图、Layout、BOM表、生产工艺</span>
          </div>
          <div class="item">
            <span>01</span>
            <span>软件资料：</span>
            <span>源代码、开发平台、烧录方式</span>
          </div>
          <div class="item">
            <span>01</span>
            <span>结构资料：</span>
            <span>BOM表、材料表、3D图档、2D图档、装配工艺</span>
          </div>
        </div>
        <div class="right_text">
          <div class="right_title">
            <img src="../assets/product/explain_2.jpg" alt="一站式服务图片" />
            <span>一站式服务</span>
          </div>
          <p>
            本公司签约长期合作伙伴，可提供一站式的批量生产服务，包括元器件供应、PCB生产、SMT贴片加工、模具开发、钣金加工、生产组装等。
          </p>
        </div>
      </div>
    </div>

    <!-- 软件定制开发 -->
    <div class="software_customization">
      <div id="software_customization" class="software_customization11"></div>
      <div class="title">
        <h2 style="margin-left:0px;font-size:36px;margin-bottom:5px">软件定制开发</h2>
        <p>我们懂开发更懂客户的需求</p>
        <p>
          按需定制，按时交付，提供各类软件量身定制开发服务，从前端、后台到云服务器一站式交付。独立项目组实时与客户对接，产品经理全程跟进把控，严格保障系统质量与开发周期。
        </p>
        <!-- <button @click="gotoContact()">联系我们 ></button> -->
         <button><a href="#/contact">联系我们 ></a></button>
        <img src="../assets/product/software.jpg" alt="软件定制开发背景图" />
      </div>
      <div class="service_content">
        <div class="left_img">
          <img src="../assets/product/service_content_img.jpg" alt="服务内容图片" />
        </div>
        <div class="right_text">
          <p>服务内容</p>
          <div class="list">
            <div class="left">
              <div class="item">
                <span>01</span>
                <span>自动化控制系统软件的定制开发</span>
              </div>
              <div class="item">
                <span>02</span>
                <span>智慧城市分项的平台软件开发</span>
              </div>
              <div class="item">
                <span>03</span>
                <span>各种行业的应用软件开发</span>
              </div>
              <div class="item">
                <span>04</span>
                <span>微信小程序定制开发</span>
              </div>
              <div class="item">
                <span>05</span>
                <span>手机APP软件开发</span>
              </div>
              <div class="item">
                <span>06</span>
                <span>软件定制开发</span>
              </div>
              <!-- <p style="font-weight: 400; font-size: 17px">
                软件系统高度灵活可配置，全面适配企业运营模式，完美应对业务变化，可根据客户需求定制化开发，包括PC端、移动端、APP、小程序、H5制作等。
              </p>
              <p style="display: flex;margin-top:40px">
                <span
                  style="
                    display: block;
                    background-color: #004aa1;
                    color: #fff;
                    border-radius: 100%;
                    padding: 8px;
                    font-weight: 600;
                    font-size: 16px;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    margin-right: 10px;
                  "
                  >01</span
                >智慧水利综合管理平台：大数据可视化展示、GIS一张图、无人值守远程控制系统、雨情自动遥测系统、自动水位站监测系统、自动流量站监测系统、水利设施安防报警系统、手机APP和后台管理系统。
              </p>
              <p style="display: flex;margin-top:40px">
                <span
                  style="
                    display: block;
                    background-color: #004aa1;
                    color: #fff;
                    border-radius: 100%;
                    padding: 8px;
                    font-weight: 600;
                    font-size: 16px;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    margin-right: 10px;
                  "
                  >02</span
                >智慧城管综合管理平台：大数据可视化展示、GIS一张图、公共服务系统、城市运行APP、智慧水务综合管理平台、智慧照明管理平台、路长制综合管理平台、闸泵远程控制系统、城市防汛监管系统、智慧公厕综合管理平台、智慧环卫综合管理平台、地热井管控平台、市容秩序提升平台、建筑垃圾综合信息管理平台、智慧工地管理平台、油烟在线监测平台、智慧园林综合管理平台、AI视频监控智能分析系统。
              </p>
              <p style="display: flex ;margin-top:40px" >
                <span
                  style="
                    display: block;
                    background-color: #004aa1;
                    color: #fff;
                    border-radius: 100%;
                    padding: 8px;
                    font-weight: 600;
                    font-size: 16px;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    margin-right: 10px;
                  "
                  >03</span
                >智慧农业综合管理平台：智能化灌溉系统、水肥一体化系统、远程信息化虫情测报系统、环境监测系统（自动气象站）、土壤墒情监控系统、智能温室监控系统、农业遥感监测平台。
              </p> -->
            </div>
          </div>
        </div>
      </div>
      <div class="service_process">
        <div class="process_title">
          <h2 style="font-size:28px;margin-left:0px">服务流程</h2>
        </div>
        <div class="process_box">
          <div class="line"></div>
          <div
            class="process_item"
            v-for="(item, index) in SprocessList"
            :key="index"
          >
            <img :src="item.icon" style="margin-top: 7px" alt="服务流程图片" />
            <div class="node">
              <span></span>
            </div>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="advantage">
        <div class="advantage_title">
            <h2 style="font-size:28px;margin-left:0px">我们的优势</h2>
        </div>
        <div class="advantage_content">
          <div class="left_text">
            <div class="advantage_item">
              <span></span>
              <div class="text">
                <p>原生开发</p>
                <p>量身定制，拒绝模板，一手源码定制开发，系统更流畅更安全。</p>
              </div>
            </div>
            <div class="advantage_item">
              <span></span>
              <div class="text">
                <p>代码规范</p>
                <p>
                  代码质量高，逻辑思维强，无任何BUG与后门，后续升级迭代投入低、时间快。
                </p>
              </div>
            </div>
            <div class="advantage_item">
              <span></span>
              <div class="text">
                <p>开发高效</p>
                <p>
                  规范高效的设计、开发、测试流程，严格控制项目进度，上线周期更短。
                </p>
              </div>
            </div>
            <div class="advantage_item">
              <span></span>
              <div class="text">
                <p>质量保证</p>
                <p>
                  多轮兼容性能测试，漏洞修复，客户验收测试，优化满意再上线。
                </p>
              </div>
            </div>
            <div class="advantage_item">
              <span></span>
              <div class="text">
                <p>交付验收</p>
                <p>
                  验收合格后，交付的不止是规范整洁的源码，还有详尽的系统设计文档。
                </p>
              </div>
            </div>
            <div class="advantage_item">
              <span></span>
              <div class="text">
                <p>专业团队</p>
                <p>
                  一流的研发团队，10年以上的项目经验，最成熟、最前沿的核心技术。
                </p>
              </div>
            </div>
            <div class="advantage_item">
              <span></span>
              <div class="text">
                <p>售后服务</p>
                <p>
                  7*24小时全时响应，终生BUG免费修复，确保及时为客户解决问题。
                </p>
              </div>
            </div>
          </div>
          <div class="right_img">
            <img src="../assets/product/advantage_img.jpg" alt="我们的优势背景图" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    filterHtmlTag(t) {
      if (!t) return "";
      return t.toString().replace(/<.*?>/g, "");
    },
  },
  metaInfo: {
    title: '智慧水利水务_农业远程控制_城市物联网管理-东营市旭瑞智能科技股份有限公司',  // 设置title
    meta: [{                 
      name: 'keywords',  // 设置关键字
      content: '智慧水利，闸泵远程控制，智慧城市，智慧城管，智慧水务，城市防汛监测，智慧闸泵，，智能灌溉，智慧水利-大数据可视化展示，智慧水利-GIS一张图，无人值守远程控制系统，雨情自动遥测系统，自动水位站监测系统，自动流量站监测系统，水利设施安防预警系统，智慧水利-后台管理子系统，智慧水利-手机APP'
    },
    {
      name: 'description',  // 设置页面描述
      content: '旭瑞智能专注于智慧水利实现对江河湖泊、水资源、水利工程、防汛抗旱、水文信息、水库安全、农田灌溉与节水以及各类涉水主体进行数字化、网格化、智能化管理。'
    }],
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      console.log(from.path);
      if (to.path == from.path) {
        this.$router.go(0);
      }
    },
  },
  data() {
    return {
      show1: false,
      HardwareList: [],
      offsetTop: 0,
      offsetHeight: 0,
      headerFixed: 0,
      // offsetTop: 0, //上层控件的位置
      // offsetWidth: 0, //控件的宽度
      // outerDivWidth: 0, //外层div
      // fixed: false, //固定状态

      Hardware: [],
      Software: [
        {
          proId: 1,
          proType: 1,
          proName: "智慧水利-大数据可视化",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧城管/大数据可视化展示2.png",
          proImg: "http://hkimg.xuruidea.com/web_img/cmp_website/yangxin.png",
          proContent:
            '<h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;"><!--[if-->一、<!--[endif]-->系统介绍</h4><p style="text-align:left;"><span style="text-align: left;">智慧水利大数据可视化系统通过水位计、流量计、闸位计、水质传感器等传感设备在线采集、监测水利设施运行状态，直观展示水位、雨量、水量、水质、工情、旱情、灾情等重点管理对象的实时数据，实现水利管理综合运营态势一屏掌握，</span>达到全域数据的可视、可管、可控，具备系统智能化、数据资源化、管理精确化的优势，保证水利设施运行安全，水利运营更高效和科学管理。<br/></p><p>水利系统监测至关重要，通过大数据可视化系统，运维管理人员能够直观、高效、准确、具体的获取一手资料，分析水利实时的运行状态，掌握水利实时的工作形态，评价水利实时的安全状况，为发现水利实时异常提供依据。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/11657261446887.png" style="max-width:100%;" contenteditable="false"/></p><h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;">二、系统功能<br/></h4><p style="text-align:left;">1、运用数据模型，集中精准展示各功能模块及各要素的重要数据、趋势分析、预警信息等，实现大数据动态化、真实化、实时化、趋势化、预警化；</p><p style="text-align:left;">2、具备子系统关键监管数据的实时展示功能，可视化展示所选区域及其子区域的资源运行情况，包括各子系统不同模块站点的设备总数、在线率等；</p><p style="text-align:left;">3、以折线图、柱状图、滚动窗等方式进行数据的动态展示，例如水情监测模块24小时水位折线图、雨情监测模块24小时降雨量折线图、积水点监测模块电子尺一周数据折线图、水位报警信息轮播等；</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;">4、通过对辖区水利各项数据及处置情况的实时直观展示，为领导决策及调度指挥提供精准的数据支撑。</p>',
          proSort: 1,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 21,
          proType: 1,
          proName: "智慧水利-GIS一张图",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧城管/GPS一张图3.png",
          proImg: null,
          proContent:
            '<h4></h4><h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;">一、系统概述</h4><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/21657260088581.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;">智慧水利GIS系统综合运用基础地理数据、水利基础数据和水利业务数据，以不同标识在带有位置坐标的地图上集中展现闸泵监控站点、测流点、雨量站、河道水位站、积水点等分布情况，并直观展示监测点位置、名称、运行状态及实时监测数据，从而实现对水利设施最完整、最彻底的管理与分析，为水利业务应用系统的快速搭建提供数据支撑。<br/></p><p style="text-align:left;">同时，该系统在GIS地图的基础上，嵌入应急事件预警模块和指挥调度模块，构成了具有扁平化、可视化、精准化指挥调度能力的“一张图”，进而实现了分析、监控、指挥、调度一体化的全域应急管理。当设备状态及通讯异常或监测数据超标时，将以图标变色闪动及文字报表形式进行自动报警，不仅节约了大量的人力物力，降低了巡检成本，而且缩短了监测时间，实现了水利设施监测的自动化、实时化、高效化。</p><p><br/></p><h4 style="text-align:left;"></h4><h4 style="text-align:left;">二、系统功能</h4><p style="text-align:left;">1、应用GIS技术与实时数据相结合，实现集智慧水利管理中所有关键监管要素于一体的一张图展示、调度</p><p style="text-align:left;">2、一张图功能模块按照设备类型、展现类型、业务类型，以不同标识展现闸泵监控站点、测流点、雨量站、河道水位站、积水点等信息，并可根据搜索需求，对设备类型、业务类型及区域进行选择性展示；</p><p style="text-align:left;">3、一张图上的标识点具备图层展示概要信息、穿透查看详情信息等功能，通过地图可直观、快速掌握各站点分布情况及站点数据的实时动态信息；</p><p style="text-align:left;">4、通过GIS地图可实现监测终端报警信息的动态显示，使水情、雨情监测预警的操作与应用更加便捷直观；</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;">5、可实现视频信息的实时调取，达到指挥调度的功能。</p>',
          proSort: 2,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 22,
          proType: 1,
          proName: "无人值守远程控制系统",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/无人值守远程控制系统3.png",
          proImg: null,
          proContent:
            '<p><b></b></p><p style="text-align:left;"><b><br/></b></p><p style="text-align:left;"><b>一、方案背景</b></p><p style="text-align:left;">随着我国科技水平和综合国力的大力提高，水利资源在国民经济建设中体现出越来越重要的地位。近几十年来，国家投入巨资，沿各大流域及其它主要河流、湖泊修建了堤防、涵闸和泵站，在山区和丘陵地区兴建拦洪、发电和灌溉工程，在无自流条件的易涝和干旱地区兴建泵站除涝抗旱。</p><p style="text-align:left;">同时，随着水利工程的大量兴建，由于我国水利设施点多、面广、量大所带来的弊端也逐渐显露出来。若采用人工值守的方式，需要多名工作人员24小时轮流值班，不仅管理成本极高，而且管理效果极差。</p><p style="text-align:left;">针对目前水利工程在实际运行过程中遇到的问题，我司自主研发的“无人值守远程智能控制系统”，便很好的解决了水利设施无人值守、远程控制、无市电供应等难题。</p><p><br/></p><p style="text-align:left;"><b>二、系统概述</b></p><p style="text-align:left;">旭瑞智能无人值守远程智能控制系统是基于我司自主研发的智能控制柜和智慧水利综合管理平台，融合物联网、远程智能控制、远程数据采集、智能传感、云计算、大数据、移动互联网等前沿技术，对江河湖泊、水资源、水利工程、防汛抗旱、水文信息、水库安全、农田灌溉与节水以及各类涉水主体进行数字化、网格化、智能化管理，极大提高了水利的信息化、智能化建设和工作效率，减少了人力、物力、财力消耗，使水利设施的管理更便捷、高效、人性化、智慧化，构建出“自然和谐共生”的智慧水利新格局。</p><p><br/></p><p style="text-align:left;"><a><b></b></a></p><p style="text-align:left;"><b>三、硬件</b><b>产品</b></p><p style="text-align:left;"><b>1</b><b>、智慧水利控制器</b></p><img src="http://files.xuruidea.com/0/20220630/image1656574318568.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><span style="font-size: 14px;">&nbsp;</span><b>① 产品功能</b></p><p>支持远程智能控制（可远程或现场精准控制闸泵的启停及升降）、远程数据采集、各种水文气象传感设备及供电信息等数据的接入、视频监控流媒体传输限流自控功能、现场校准、本地WEB升级程序、远程升级程序、远程修改设备IP端口、远程重启设备、本地USB查看设备日志/本地USB升级。</p><p style="text-align:left;"><b>② 技术参数</b></p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->超低功耗：DC8-36V宽电压供电，电流≤500mA，超高电压自动断电保护，防电源反接，防浪涌，ESD防静电等保护；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->RS232接口：标准RS232通讯接口；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->RS485接口：最大设备节点255个；支持2路RS485，1路RS232，1路以太网，4路模拟量采集，4路数字量采集；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->GPRS传输：支持全网通3G/4G/5G传输；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->以太网接口：10MB/100MB自适应；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->编码器接口：支持多种编码器的接入；</p><p style="text-align:left;">●&nbsp;&nbsp;<!--[endif]-->RJ-45网口防雷保护，全金属外壳保护等级IP30，软硬件双重看门狗防死机设计。</p><p style="text-align:left;">③&nbsp;<b>应用场景</b>：节制闸、泵站、橡胶坝、翻板闸、钢板闸等智慧水利（务）行业。</p><p><br/></p><p style="text-align:left;"><b></b></p><p style="text-align:left;"><b>2</b><b>、智慧水利控制柜</b></p><p style="text-align:left;"><b></b></p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/11657260655748.jpg" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b></b></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp;</span><b>① 产品特点</b></p><p style="text-align:left;">集成远程控制、雨情遥测、水文气象信息、供电信息、无线传输、水利设施安防预警信息采集等功能端口，也可根据需求定制开发。</p><p style="text-align:left;"><b>② 技术参数</b></p><p style="text-align:left;"><span style="text-align: center;">●&nbsp;&nbsp;</span><b>智慧水利控制柜：</b>双层防水防尘设计；含闸位信息采集终端、闸门专用控制单元、电压电流采集终端、无线传输终端（不含物联网卡）、继电器、断路器、端子、线缆等辅材（不含动力电缆）；具有急停保护功能；1台控制柜可同时控制5孔闸；</p><p style="text-align:left;"><span style="text-align: center;">●</span>&nbsp;&nbsp;<b>人机交互界面：</b>10"液晶触摸屏，12V供电，分辨率：800*600；</p><p style="text-align:left;"><span style="text-align: center;">●</span>&nbsp;&nbsp;<b>智能控制器：</b>可远程或现场精准控制闸泵的启停及升降；支持现场校准；支持全网通4G/5G通讯；支持本地WEB升级程序；支持远程升级程序；超低功耗：DC8-36V宽电压供电，电流≤500mA，超高电压自动断电保护，防电源反接，防浪涌，ESD防静电等保护；RJ-45网口防雷保护，全金属外壳保护等级IP30，软硬件双重看门狗防死机设计；远程修改设备IP端口，远程重启设备，远程升级；本地USB查看设备日志，本地USB升级；标准RS232通讯接口；RS485接口：最大设备节点255个；支持2路RS485，1路RS232，1路以太网，4路模拟量采集，4路数字量采集；支持多种编码器的接入；GPRS传输；以太网接口：10MB/100MB自适应；支持各种水文气象传感设备及供电信息等数据的接入；具有视频监控流媒体传输限流自控功能。</p><p style="text-align:left;"><span style="text-align: center;">●</span>&nbsp;&nbsp;设备运行时具有对静电放电、电快速瞬变脉冲群、浪涌（冲击）的抗扰度。</p><p style="text-align:left;"><b>③ 应用场景：</b>可应用于节制闸、泵站、橡胶坝、翻板闸、钢板闸等智慧水利（务）行业。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220630/image1656574514552.png" style="max-width:100%;" contenteditable="false"/>\n<b></b></p><p style="text-align:left;"><b><br/></b></p><p style="text-align:left;"><b>三、系统功能</b></p><p style="text-align:left;">无人值守远程智能控制系统具有大数据可视化、GIS一张图、闸泵无人值守远程控制、视频监控总览、系统设置、用户权限、操作日志等功能模块，并可扩展自动水位站、自动流量站、雨情遥测、水利设施安防预警、灌区节水、山洪预警等功能模块。</p><p style="text-align:left;"><b>1.&nbsp;&nbsp; </b><b>大数据可视化展示</b></p><p style="text-align:left;">基于业务及GIS等引擎，集中精准展示节制闸、泵站等模块的重要数据、趋势分析、预警信息等，实现大数据动态化、真实化、实时化、趋势化、预警化，为领导决策及调度指挥提供了精准的数据支撑。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/11657262269535.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>2.&nbsp;&nbsp;\n</b><b>GIS</b><b>地图展示</b></p><p style="text-align:left;">应用GIS技术与实时数据相结合，直观显示各节制闸、泵站的分布位置、供电信息、设备运行情况等关键监管要素，帮助管理人员快速掌握各站点分布情况及站点数据的实时动态信息。</p><p style="text-align:center;"><br/><img src="http://files.xuruidea.com/0/20220708/31657262296581.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>3.&nbsp;&nbsp; </b><b>拦河闸管理</b></p><p style="text-align:left;">通过现场各传感设备及视频监控的实时数据采集和上传等功能，实现拦河闸站内设备运行情况的实时观测，为领导决策提供直观的图像信息，并通过现场人工操作、后台管理软件或手机APP对拦河闸水利设施进行远程精准控制，实现闸门开启高度的设定、闸门的关闭与设备的暂停等功能，有效减少了人力物力，达到无人值守的目的。</p><p style="text-align:left;">同时，系统具备水位超高自动报警功能，当河道水位达到警戒水位时，远程控制平台软件可自动发出警报信息至管理员的手机，提醒工作人员进行紧急处理，最大程度地减少危害和影响。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/41657262365890.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>4.&nbsp;&nbsp; </b><b>泵站管理</b></p><p style="text-align:left;">通过前端泵站的视频监控，可实现泵站设备运行情况的实时观测，为领导决策提供直观的图像信息，减少人力物力；并通过后台管理软件或手机APP对泵站等水利设施进行远程精准控制，包括远程开启、关闭、暂停等。</p><p style="text-align:left;">同时，通过现场各传感设备实时的数据采集和上传等功能，实现泵站瞬间流量、累计水量、水位、流速、灌溉面积、设备状态等动态实时信息的展示与调取，为领导决策提供数据依据。<b></b></p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/51657262408909.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>5.&nbsp;&nbsp; </b><b>查询管理</b></p><p style="text-align:left;">提供了泵站、闸门、视频设备的查询功能，工作人员通过查询条件的筛选可直接对各个泵站、闸门、视频设备数据或者某个时间段内的设备信息进行查询，实现所属资源的信息化与可视化管理，为资源的管理与配置、扩容与维护、决策与调度提供更直观、更精准的数据支撑。</p><p><img src="http://files.xuruidea.com/0/20220708/61657262511299.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>6.&nbsp;&nbsp; </b><b>系统管理</b></p><p style="text-align:left;">具有权限管理、用户管理和角色管理三种功能：权限管理可针对不同用户的工作需要，进行权限设定和管理；用户管理包括用户名称、所属角色、联系电话等信息的记录，并具备用户的新增与删除功能；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</p><p><img src="http://files.xuruidea.com/0/20220708/71657262545952.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>7.&nbsp;&nbsp; </b><b>操作日志</b></p><p style="text-align:left;">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/微信截图_202207081442421657262577287.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b>8.&nbsp;&nbsp; </b><b>手机APP</b></p><p style="text-align:left;">无人值守远程控制App，运用数字化、信息化、智能化手段提升闸泵预警管理效能，以闸门、泵站管理功能模板为主，支持短信预测、报警记录、数据统计分析、报警信息等等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使无人值守远程控制管理工作更简单、便捷、高效。&nbsp;&nbsp;</p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/图片11657260986795.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b></b></p><p style="text-align:center;"><img src="http://files.xuruidea.com/0/20220708/图片41657261023545.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;"><br/></span></p><p style="text-align:left;"><b>四、案例展示</b></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657520882344.png" contenteditable="false" style="font-size: 14px; max-width: 100%;"/>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 节制闸（单孔）&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;节制闸（双孔）</p><img src="http://files.xuruidea.com/0/20220711/991657521080118.png" style="max-width:100%;" contenteditable="false"/><span style="font-size: 16px; text-align: center;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 橡胶坝</span><div><span style="font-size: 16px;"><br/><br/></span></div><div><span style="font-size: 16px;"><br/></span></div>',
          proSort: 3,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 23,
          proType: 1,
          proName: "雨情自动遥测系统",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/雨情自动遥测系统3.png",
          proImg: null,
          proContent:
            '<p><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><b><font size="4" color="#000000">一、方案背景</font></b></p><p style="text-align:left;"><font color="#000000">每年4到10月份都是我国的汛期，水旱灾害防御形势日趋紧张。在汛期，防汛抗洪一直都是重中之重，降雨量增大所引发的洪涝灾害严重影响到了人民的生命财产安全。近几年来，国家一直呼吁各省市地区汛期做好洪涝灾害的防御<a href="http://baike.eastmoney.com/item/%E5%B7%A5%E4%BD%9C" target="http://finance.eastmoney.com/a/_blank"><font color="#000000">工作</font><span></span><span></span></a>，第一时间掌握雨情数据也就掌握了防汛抗洪的主动权，最大程度避免洪涝灾害的发生。</font></p><p style="text-align:left;"><font color="#000000">雨情实时变化难以预测，不同区域降雨量有很大差异，如果依靠传统人力大范围观察降雨量非常被动。我司自主研发的雨情自动遥测系统可以提供全方位的雨情数据，能够让工作人员第一时间了解到大范围内雨情的实时变化，在节省人力物力的同时提高数据的准确性。</font></p><p style="text-align:left;"><font color="#000000"><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a></font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font size="4" color="#000000">二、系统概述</font></b></p><p style="text-align:left;"><font color="#000000">雨情自动遥测系统是基于GIS地图开发，集信息采集、传输、分析和预警等多功能于一体，能够在线显示、统计、上传降雨量的自动化遥测平台，实时采集降雨量数据，在不同区域分别显示降雨量情况。</font></p><p style="text-align:left;"><font color="#000000">该系统采用软硬件结合方式，目标地点放置自动雨量站实时监测雨量数据</font><span style="color: rgb(0, 0, 0);">，再由无线网络(GPRS、CDMA)传输到管理者的电脑WEB端或手机app上，能够让管理者第一时间了解到雨情的变化；系统具有定时自报功能，定时报送水文数据。在监测到雨情流量超过预设值（自行设置预设值）时系统会自动向管理者电脑网页发送报警信息，以便管理者第一时间处理警情；系统的硬件平台采用双供电方式，内置有高性能电池。</span></p><p style="text-align:left;"><font color="#000000">使用者可以在电脑WEB端查看历史雨情数据、设备分布图、降雨统计以及雨量监测数据。该系统集成信息的汇集、处理、应用、分析、发布以及后续处理工作。广泛应用于防汛、气象、城市排涝等工作。通过平台，可实现雨情的实时预警，以保证水库、渠道及建筑物的安全；根据雨情分析灌区需水量和来水量，实现水量的科学配置；依靠暴雨时的雨情监测，为区域的防汛排洪提供辅助决策依据。</font></p><p style="text-align:left;"><font color="#000000"><br/><img src="http://files.xuruidea.com/0/20220630/image1656576993405.png" width="100%"/><br/><!--[endif]--></font></p><p style="text-align:left;"><b><a><font color="#000000"><br/></font></a></b></p><p><font color="#000000"><b><font size="4">三、硬件产品</font></b></font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577018872.png" style="font-size: 14px; max-width: 100%;" width="100%" contenteditable="false"/><b><font color="#000000"><!--[endif]--></font></b></p><p style="text-align:left;"><!--[if--><font color="#000000">①　<!--[endif]-->可外接雨量传感器；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">②　<!--[endif]-->4G、CDMA任意两种信道相连的接口；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">③　<!--[endif]-->具有定时自报和响应召测兼容的工作体制；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">④　<!--[endif]-->具备主备信道切换、发送确认、自动补发功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑤　<!--[endif]-->具备电源检测与管理、报警功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑥　<!--[endif]-->具备防盗开关信号接入与检测功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑦　<!--[endif]-->具备数据保护不丢失功能；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑧　<!--[endif]-->具备自检自诊断功能，死机自动复位；</font></p><p style="text-align:left;"><!--[if--><font color="#000000">⑨　<!--[endif]-->具备自动同步时钟功能。</font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font size="4" color="#000000">四、系统功能</font></b></p><p style="text-align:left;"><font size="3"><b><span style="color: rgb(0, 0, 0);">1</span><span style="color: rgb(0, 0, 0);">、GIS地图展示</span></b></font></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">基于GIS地图开发并集中显示各遥测雨量站的分布位置（按经纬度）、降雨量数据等，同时根据降雨量级对雨量站进行颜色标注，方便工作人员快速掌握各站点的雨量信息，并及时做出决策。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/101657264981427.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">2、</span><b style="color: rgb(0, 0, 0);">雨情监测管理</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">通过点击站点图标，可实现降雨状态、当前降雨起始时间、降雨时长、当前累计降雨量、实时水位等动态实时信息的展示与调取。同时，通过监测终端报警功能，实现全方位、全天候、全时段雨量超标实时报警，并以短信和APP通知形式发送至相关管理人员，实现自动预警、自动防控功能。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/91657262700933.png" style="max-width:100%;" width="100%" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">3</b><b style="color: rgb(0, 0, 0);">、雨情分析管理</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">系统通过24小时降雨量统计折线图、雨情月报表以及雨情年报表，帮助管理人员迅速掌握雨量变化信息，提前做好防控准备，并为后期决策提供数据支持。同时，系统提供了雨情查询功能，管理人员通过搜索栏可直接查询各雨量站或者某天、某月、某年的雨情信息。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/111657265043413.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">4</b><b style="color: rgb(0, 0, 0);">、系统管理</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">具有权限管理、用户管理和角色管理三种功能：权限管理可针对不同用户的工作需要，进行权限设定和管理；用户管理包括用户名称、所属角色、联系电话等信息的记录，并具备用户的新增与删除功能；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</span></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220708/121657265079310.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">5</b><b style="color: rgb(0, 0, 0);">、操作日志</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</span></p><p><img src="http://files.xuruidea.com/0/20220708/131657265110522.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><b style="color: rgb(0, 0, 0);">6</b><b style="color: rgb(0, 0, 0);">、手机APP</b></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">雨情自动遥测App，运用数字化、信息化、智能化手段提升雨情预警管理效能，支持短信预测、报警记录、数据统计分析、报警信息等等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使无人值守远程控制管理工作更简单、便捷、高效。</span></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);"><br/></span></p><p style="text-align:left;"><font color="#000000"><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a><a></a></font></p><p style="text-align:left;"><b><font size="4" color="#000000">五、案例展示</font></b></p><p><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</font></p><p>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p><img src="http://files.xuruidea.com/0/20220630/image1656577181985.png" style="font-size: 14px; max-width: 100%;" width="100%" contenteditable="false"/><!--[endif]--><!--[endif]--></p><br/>',
          proSort: 4,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 24,
          proType: 1,
          proName: "自动水位站监测系统",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/自动水位监测系统3.png",
          proImg: null,
          proContent:
            '<p><a></a></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><b><font color="#000000">一、方案背景</font></b></p><p style="text-align:left;"><font color="#000000">近几年随着环境的持续恶化，各种自然灾害频繁发生，尤其是水灾的发生给我国带来了巨大的经济损失和人员伤亡。汛期来临时，及时获得河道水库的水位涨幅数据对开展防汛抗洪工作至关重要，大量河道水库分布在远离城市的区域，而且分散，尤其是在紧急防汛阶段，如果只依靠传统人力巡查获得河道水位数据必将耗费大量人力物力。</font></p><p style="text-align:left;"><font color="#000000">我公司的智慧水利河道自动水位站监测预警系统可以为用户提供专业全面的水位监测控制管理，由水位传感器监测到水位的实时变化，将数据传递给管理者WEB端或手机APP。相比于传统水位站，具有快速查看数据、超限自动报警、自动记录上传等优点，使用者无须到达水位站，在电脑或手机就可以查看到详细数据，方便快捷又准确。</font></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><font color="#000000"><a></a></font></p><p style="text-align:left;"><b><font color="#000000">二、系统概述</font></b></p><p style="text-align:left;"><font color="#000000">河道自动水位监测预警系统通过雷达或压力式水位传感器来感知水位变化，集太阳能供电、视频监控和无线传输设备于一体，具有水位采集、超限报警、自动记录上传、低电量报警、站点档案查看等功能，实时监测到的水位数据会通过GPRS、4G(移动、联通、电信）信号传输到独立的云服务器，再由云服务器平台将数据发送到使用者的电脑WEB端或手机APP上，便于水利或城市管理部门监测流域的实时水位、天气等数据。</font></p><p style="text-align:left;"><font color="#000000">河流水位监测预警系统是实时掌握河道水情变化，科学预警洪涝灾害、提升防汛指挥能力、降低雨洪灾害损失的重要手段，实现了对河流的信息化管理，很大程度避免了水位过高导致河流决堤的危险发生，在保护人民生命、财产安全方面发挥了重大作用。</font></p><p style="text-align:left;"><font color="#000000"><br/></font></p><p style="text-align:left;"><font color="#000000"><b></b></font></p><p style="text-align:left;"><b><font color="#000000">三、硬件产品</font></b></p><p style="text-align:left;"><font color="#000000">自动水位监测预警系统由雷达或压力式水位传感器来感知水位变化，集太阳能供电、视频监控和无线传输设备于一体，具有水位采集、趋势分析、超限报警、自动记录上传、低电量报警、站点档案查看等功能；实时监测到的水位数据会通过GPRS、4G/5G(支持全网通）信号传输到使用者的电脑WEB端或手机APP上，便于水利或城市管理部门监测流域的实时水位、天气等数据。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577287290.png" style="max-width:100%; text-align:left;" contenteditable="false"/><font style="text-align:left;" color="#000000"><br style="text-align:left;"/></font><p style="text-align:left;"><font color="#000000"><b>1、</b><b>雷达水位计</b></font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;测量范围：30米/70米可选；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;过程连接：螺纹G1½ʺ A / 支架/法兰；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;过程温度：-40～100℃；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;过程压力：常压；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;精度：±2mm；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;频率范围：26GHz；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;防护等级：IP67 ；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;供电电源： DC（6—24V）/四线；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;信号输出：RS485/Modbus 协议。</font></p><p style="text-align:left;"><font color="#000000"><b>2、</b><b>遥测终端机</b></font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;支持全网通；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具有定时自报和响应召测兼容的工作体制；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具备主备信道切换、发送确认、自动补发功能；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp; 具备电源检测与管理、报警功能；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具备数据保护不丢失功能；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp;&nbsp;具备自建自诊断功能，死机自动复位；</font></p><p style="text-align:left;"><font color="#000000"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span>&nbsp; 具备自动同步时钟功能。</font></p><p style="text-align:left;"><font color="#000000"><b>3、</b><b>视频监控</b></font></p><p style="text-align:left;"><font color="#000000">高清智能球，实时监控河流区域画面，采集的监控数据自动上传到云平台，用户通过电脑或手机端对河道水位、水情进行远程查看。</font></p><p style="text-align:left;"><font color="#000000"><b>4、</b><b>水位监测杆</b></font></p><p style="text-align:left;"><font color="#000000">采用优质钢材，顶端用盖板封闭，底部配置检修口；整体进行防锈、防腐蚀处理；抗风等级9级。</font></p><p style="text-align:left;"><font color="#000000"><b>5、</b><b>太阳能发电</b></font></p><p style="text-align:left;"><font color="#000000">由蓄电池、太阳能板、充电控制器、信号避雷器、支架等组成。</font></p><p style="text-align:left;"><font color="#000000"><b></b></font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font color="#000000">四、系统功能</font></b></p><p style="text-align:left;"><font color="#000000"><b>1</b><b>、GIS地图展示</b></font></p><p style="text-align:left;"><font color="#000000">系统运用物联网感知手段实时采集河道水位、流量等数据信息，并通过GIS地图直观展示各河道水位监测站的分布位置、水位信息、设备状态、电池状态等。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577307652.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>2</b><b>、防汛指挥模式</b></font></p><p style="text-align:left;"><font color="#000000">当有汛情时，可切换至此模式，界面集中展示报警水位站的实时水位情况，可任意调取水位站的实时监控图像，并参照实时的天气预报信息，可对汛情做出及时的决策和处置方案，使报警与指挥融为一体，让防汛工作的开展更精准、更具有时效性。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577316174.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>3</b><b>、水位实时数据</b></font></p><p style="text-align:left;"><font color="#000000">实时显示各水位站的水位、瞬时流量、流速、警戒水位等水文信息，以及各水位站的水位小时变化曲线图。并通过提供360度现场监控图像，实现水位信息的动态实时展示与调取。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577324430.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>4</b><b>、报警管理</b></font></p><p style="text-align:left;"><font color="#000000">当水位高于警戒水位时，系统会通过手机短信、平台预警、APP预警等多种提示方式发送至管理人员手机，责任人根据情况可及时采取应对措施并上传预警处置记录。通过监测终端报警，实现了城市防汛的自动预警、自动防控功能。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577331329.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>5</b><b>、设备管理</b></font></p><p style="text-align:left;"><font color="#000000">将GIS技术与实时数据相结合，对资源数据和信息进行采集、储存、管理、显示和描述，包括水位设备的状态及点位分布，太阳能设备的数量、电量、状态及站点信息，监控设备的数量、点位及监控状态等，实现所属资源的信息化与可视化管理，为资源的管理与配置、扩容与维护、决策与调度提供更直观、更精准的数据支撑。</font></p><p style="text-align:left;"><font color="#000000">同时通过平台，可对站点及设备信息进行管理，包括站点及设备的新增、修改、删除，以及水位警戒值的设定等。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577338666.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><font color="#000000"><b>6</b><b>、系统管理</b></font></p><p style="text-align:left;"><font color="#000000">具有组织结构、用户管理和角色管理三种功能：组织结构可对组织名称、地址进行编辑管理；用户管理包括用户名称、所属角色、联系电话等，可实现用户的新增、编辑、修改和删除；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577346621.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><font color="#000000"><b>7</b><b>、操作日志</b></font></p><p style="text-align:left;"><font color="#000000">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</font></p><p style="text-align:left;">&nbsp;&nbsp;<img src="http://files.xuruidea.com/0/20220630/image1656577353068.png" style="max-width:100%;" contenteditable="false"/>&nbsp;<!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>8</b><b>、手机APP</b></font></p><p style="text-align:left;"><font color="#000000">自动水位站监测App，运用数字化、信息化、智能化手段提升城市防汛监测预警管理效能，以水位站管理功能模板为主，支持短信预测、报警记录、数据统计分析、报警信息等等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使城市防汛管理工作更简单、便捷、高效。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577362335.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><a><font color="#000000"><br/></font></a></p><p style="text-align:left;"><a><font color="#000000"><b>五、案例展示</b></font></a></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577372983.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <font face="楷体">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;河道水位站</font></font></p>',
          proSort: 5,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 25,
          proType: 1,
          proName: "自动流量站监测系统",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/自动流量站监测系统3.png",
          proImg: null,
          proContent:
            '<h1 style="text-align:left;"><font color="#000000"><b style="font-size: 16px;">一、方案背景</b><br/></font></h1><p style="text-align:left;"><font color="#000000">传统的水文测验是一直沿用测深杆或测绳测深，起点距标志牌定位，流速仪或浮标测速，手工计算。测流量前首先需要施测各测点流速，最后计算出断面流量。人工记数与计算很容易出错，而且测流准备工作繁琐，耗费人力资源量大，测流速度慢，功效低。随着最严格水资源管理制度的落实，对区域出入境水量统一调度要求越来越高。为适应新时期水文测报快速、准确、精度高、任务多的要求，旭瑞智能自主研发的自动测流站监测系统，较好的解决了这一问题。</font></p><p><font color="#000000"><br/></font></p><h4 style="text-align:left;"></h4><h4 style="text-align:left;"><font color="#000000">二、方案概述</font></h4><p style="text-align:left;"><font color="#000000">自动流量站监测系统是用来监测河道水文流量的平台，可以有效对河道流速、水位、瞬间流量、累计流量等数据进行实时监测和统计， 如有险情，第一时间采取应对措施，为保障流域内适度蓄水和安全度汛提供了准确、及时的现场信息，能够真正做到防灾减灾、水情预警等大数据应用需求，对防洪减灾工作的有序进行具有重大意义。</font></p><p style="text-align:left;"><font color="#000000">通过现场各种探测器，将探测到的水流速、瞬时流量、水位、累计流量、视频图像或图片等数字化信息，通过4G/5G通道上传到在线监测监视中心。系统可以实时监测流量状况，可以提供在线数据查询及统计分析，能够为河道水文流量的监测和管理提供数据分析和决策依据，并为河道治理提供丰富的数据支持。</font></p><h4 style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577465510.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></h4><h4 style="text-align:left;"><font color="#000000"><br/></font></h4><h4 style="text-align:left;"><font color="#000000">三、系统功能</font></h4><p style="text-align:left;"><font color="#000000"><b>1</b><b>、GIS地图展示</b></font></p><p style="text-align:left;"><font color="#000000">通过GIS地图，集中展示测流点的具体位置及分布情况，并以不同颜色对站点情况进行标识；通过点击站点图标，可实现测流点名称、流速、水位、经纬度、瞬间流量、累计流量及采集时间等动态实时信息的展示与调取。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577472933.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>2</b><b>、流量点管理</b></font></p><p style="text-align:left;"><font color="#000000">提供了测流点流量查询功能，管理人员通过搜索栏可直接查询各个流量点数据或者某个日期的流量信息。同时，通过平台，可对站点信息进行管理，包括站点的新增、修改、删除等。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577482947.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000"><b>3</b><b>、测流点历史记录</b></font></p><p style="text-align:left;"><font color="#000000">提供了测流点历史记录功能，管理人员通过搜索栏可直接查询各个流量点数据或者某个时间段内的流量信息，帮助管理人员迅速掌握河道流量变化信息，提前做好防控准备，并为后期决策提供数据支持。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577492393.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>4</b><b>、系统管理</b></font></p><p style="text-align:left;"><font color="#000000">具有权限管理、用户管理和角色管理三种功能：权限管理可针对不同用户的工作需要，进行权限设定和管理；用户管理包括用户名称、所属角色、联系电话等信息的记录，并具备用户的新增与删除功能；角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</font></p><img src="http://files.xuruidea.com/0/20220630/image1656577500978.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;"><font color="#000000"><b>5</b><b>、操作日志</b></font></p><p style="text-align:left;"><font color="#000000">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属角色、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577507340.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><font color="#000000"><b>6</b><b>、手机APP</b></font></p><p style="text-align:left;"><font color="#000000">自动流量站监测App，运用数字化、信息化、智能化手段提升河道流量管理效能，以流量站管理功能模板为主，支持短信预测、报警记录、数据统计分析、报警信息等功能；可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便管理人员随时查看并处理，有效提升了行政效能，使流量管理工作更简单、便捷、高效。</font></p><p style="text-align:left;"><font color="#000000"><b><br/></b></font></p><p style="text-align:left;"><font color="#000000"><b>四、案例展示</b></font></p><img src="http://files.xuruidea.com/0/20220630/image1656577514357.png" style="max-width:100%; text-align:left;" contenteditable="false"/><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <font face="楷体">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 自动流量站</font></font></p>',
          proSort: 6,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 26,
          proType: 1,
          proName: "水利设施安防预警系统",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/安防报警系统3.png",
          proImg: null,
          proContent:
            '<h1 style="text-align:left;"><b style="color: rgb(0, 0, 0); font-size: 16px;"><br/></b></h1><h1 style="text-align:left;"><b style="color: rgb(0, 0, 0); font-size: 16px;">一、方案背景</b><br/></h1><p style="text-align:left;"><font color="#000000">近年来，水利设施盗窃、毁坏案件频繁发生，一些防洪、排涝、灌溉等金属铸件和泵房内动力及配套附件设备的毁坏及丢失，不仅造成严重的经济损失，也严重威胁到防汛抗旱工作的安全有序进行。据不完全统计，每年水利设施因人为破坏造成的直接经济损失在1.5亿元左右。各大江河防洪工程设施被破坏问题不断发生，每年被盗割的防汛通信线达10余万米，严重影响防汛指挥。一些提防被挖毁，防洪闸启闭机被盗窃哄抢，在洪水来临的关键时刻无法提闸，被迫炸闸泄洪。各大中型水库的设施常遭破坏，有的大坝被不法分子炸裂，严重威胁下游安全。一些水文测报站（点）的设施遭严重破坏，有的水文站被歹徒洗劫一空，人员被殴打致伤致残。农田灌排设施遭破坏的情况也十分突出，造成大片农田无法及时灌溉，影响农业生产和农业基础的稳定。</font></p><p style="text-align:left;"><font color="#000000">水利是国民经济的基础产业和基础设施，在社会主义现代化建设中起着十分重要的作用。水利设施尤其是防洪工程的安全，事关国计民生、改革开放和社会稳定的大局。为了切实保证水利设施的安全，旭瑞智能自主研发的水利设施安防报警系统，有效降低了水利设施盗窃案发率，规避了损失风险。</font></p><p style="text-align:left;"><b><font color="#000000"><br/></font></b></p><p style="text-align:left;"><b><font color="#000000">二、方案概述</font></b><br/></p><p style="text-align:left;"><font color="#000000">旭瑞智能借助多年智慧水利项目建设经验，经过技术研发与创新，不断改进和完善水利设施安防系统的功能与性能，在常规安防预警措施的基础上，增加全国首推存储设备定位追回系统，大大提高了水利设施的安全防护级别。旭瑞智能水利设施安防预警系统主要由下列五大子系统组成：&nbsp;&nbsp;</font></p><h5 style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577570631.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></h5><h5 style="text-align:left;"></h5><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font size="4" color="#000000"><br/></font></h5><h5 style="text-align:left;"><font size="4" color="#000000">三、系统功能</font></h5><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font size="2" color="#000000">1、自动语音警告系统 </font></h5><p style="text-align:left;"><font color="#000000">当现场有人非法入侵时，自动语音警告系统开启，并循环播放提前录入的语音警告，直至入侵者离开。语音警告可实现循环播放录制的语音，配置高保真音箱。可插U盘，可选择语音。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657522071194.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font face="楷体">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1.<span style="color: rgb(0, 0, 0);">探测到有人距离设施过近&nbsp;&nbsp;&nbsp; 2.设备系统进行语音警告 &nbsp;&nbsp;&nbsp;&nbsp; </span><span style="color: rgb(0, 0, 0);">3.持续进行语音警告&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4、直至入侵者离开</span></font></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">2、远程人工喊话系统</font></h5><p style="text-align:left;"><font color="#000000">当有人距离水利设施过近，并且自动语音警告系统连续开启超过3次以上时（次数可后台设置），位于使用单位控制中心的电脑平台和手机APP上会弹出报警信息和提醒。此时，管理人员可通过调取实时监控视频来查看现场情况，决定是否进行远程人工喊话对入侵人员进行驱离。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657522437903.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000"><font face="楷体">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1.自动语音警告连续三次对其无效&nbsp; &nbsp; &nbsp; 2.管理工作人员查看实时监控视频&nbsp; &nbsp; &nbsp; </font></font><span style="color: rgb(0, 0, 0);"><font face="楷体">3.对入侵者开展远程人工喊话&nbsp; &nbsp; &nbsp;4.直到入侵者离开现场</font></span></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">3、门禁报警系统&nbsp;&nbsp;</font></h5><p style="text-align:left;"><font color="#000000">水利设施的电器设备远离城区，更容易被犯罪分子盯上，为了更大程度保护水利设备，我们在闸泵房的防盗门上加装了门禁报警系统。当泵房或闸室的门关闭后，门禁系统自动处于布防状态；门被打开时，门禁报警系统自动启动，同时开启声光（闪烁红色灯光并发出刺耳声音）报警，同时报警系统向平台发送报警信息。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657522759402.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><span style="color: rgb(0, 0, 0);">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <font face="楷体">&nbsp;1. 有人接近泵房&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;2.入侵者打开闸泵房防盗门&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</font></span><font face="楷体"><span style="color: rgb(0, 0, 0);">3.\n</span><span style="color: rgb(0, 0, 0);">门禁报警系统开始运行&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 4.开启声光报警(闪烁红色)</span></font></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">4、智能分析监控系统</font></h5><p style="text-align:left;"><font color="#000000">在泵房或者闸室安装具有AI智能分析功能的高清摄像机，360度无死角监控周边情况，当有人非法入侵时，可实现对入侵者的脸部进行抓拍与跟踪，能够在连续跟踪进程中保证抓拍到正面人脸，记录质量最高的面部图像并将完整的录像上传。支持镜头遮挡、视频丢失等报警功能。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657523033125.png" style="max-width:100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<font face="楷体">&nbsp; 1.装有水利设备的泵房或者闸室&nbsp; &nbsp; &nbsp; &nbsp; 2.AI智能分析高清摄像机&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</font></font><span style="color: rgb(0, 0, 0);"><font face="楷体">3.监控入侵人员的行动轨迹&nbsp; &nbsp; &nbsp; &nbsp; 4.对人员的面部进行清晰拍照</font></span></p><h5 style="text-align:left;"><font color="#000000"><br/></font></h5><h5 style="text-align:left;"><font color="#000000">5、存储设备定位追回系统</font></h5><p style="text-align:left;"><font color="#000000">对水利设施安防系统中的存储设备安装GPS定位系统，并具有双供电功能，内置高性能电池，外部供电中断时，仍可实现55天的正常工作，定位精准度高。当现场的存储设备遭到非法盗取时，可通过设备定位系统进行跟踪、定位、报警、追回。</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;防拆报警：可实现拆除时发送报警信息。&nbsp; &nbsp;</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;位移报警：可以实现设备移动时发送报警信息。&nbsp; &nbsp;</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;低电压报警：可实现电压低于5%时发送报警信息。&nbsp; &nbsp;</font></p><p style="text-align:left;"><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center; font-size: 14px;">&nbsp; &nbsp;&nbsp;</span><span style="text-align: center;">●</span><font color="#000000">&nbsp;&nbsp;GPS+北斗定位：(定位精度：2.5m，高灵敏度：-165dBm)，4G/5G通讯。</font></p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220711/991657523381465.png" style="font-size: 14px; max-width: 100%;" contenteditable="false"/></p><p style="text-align:left;"><font color="#000000">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<font face="楷体">&nbsp;1.安装有设备的泵房&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;2.泵房内的储存设备&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</font></font><span style="color: rgb(0, 0, 0);"><font face="楷体">3.丢失存储设备的精准定位&nbsp; &nbsp; &nbsp; &nbsp; 4.详细记录丢失设备被运输的路径</font></span></p>',
          proSort: 7,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 27,
          proType: 1,
          proName: "智慧水利-后台管理子系统",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/智慧水利-后台管理子系统-02.png",
          proImg: null,
          proContent:
            '<h1 style="text-align:left;"><b style="font-size: 16px;"><br/></b></h1><h1 style="text-align:left;"><b style="font-size: 16px;">一、</b><b style="font-size: 16px;">系统概述</b><br/></h1><p style="text-align:left;">后台管理系统是对系统使用者的各类基础信息进行维护和管理，主要功能包含用户管理、角色管理、权限管理及操作日志等，能够更好的管理各个业务流程步骤中每一位用户的权限，防止用户操作混乱，使流程更清晰、任务更明确。</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577863764.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><b><br/></b></p><p style="text-align:left;"><b>二、系统功能</b></p><p style="text-align:left;"><b>1</b><b>、用户管理模块</b></p><p style="text-align:left;">可对用户信息、组织机构信息等进行管理，包括对组织机构及用户信息的新增、编辑、修改、删除和账户禁用等功能；同时系统具备组织架构职责权限设置的功能。</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577872161.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><b>2</b><b>、角色管理模块</b></p><p style="text-align:left;">角色管理主要是根据用户的职务、管理范围自定义设置多级管理权限及角色，可编辑修改用户的使用状态，可以对用户权限进行编辑和删除，提高系统管理与使用的安全级别。</p><p style="text-align:left;">采用最安全且强大的shiro安全框架进行系统开发,按照安全规则或者安全策略使用户可以访问且只能访问自己被授权的资源，实现对用户访问权限的控制。</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577879848.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p><p style="text-align:left;"><b>3</b><b>、操作日志模块</b></p><p style="text-align:left;">对系统操作者的每一次操作进行记录、统计和查询展示，包括操作时间、操作人姓名、所属部门、岗位、操作模块名称、操作具体内容等，提高软件系统运行与操作的安全级别，实现异常操作的有据可查及追责取证。</p><p style="text-align:left;">通过使用Log4j开发技术，可将日志信息输送的目的地设定为控制台、文件、GUI组件、甚至是套接口服务器、NT的事件记录器、UNIX Syslog守护进程等。</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;"><img src="http://files.xuruidea.com/0/20220630/image1656577887802.png" style="max-width:100%;" contenteditable="false"/><!--[endif]--></p>',
          proSort: 8,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
        {
          proId: 28,
          proType: 1,
          proName: "智慧水利-手机APP",
          proIcon:
            "http://hkimg.xuruidea.com/web_img/cmp_website/系统平台icon/智慧水利/智慧水利手机APP-02.png",
          proImg: null,
          proContent:
            '<h4></h4><h4 style="text-align:left;"><br/></h4><h4 style="text-align:left;"><!--[if-->一、<!--[endif]-->系统概述</h4><p style="text-align:left;">智慧水利手机APP是一款基于智慧水利综合管理平台，专为水利设施设备运维及管理人员打造的一款移动软件，支持实时数据查询、设备报警、远程控制、实时监控、工单处理等功能，为水利相关管理部门的日常工作提供更便捷、更高效的管理模式。</p><p style="text-align:left;">智慧水利手机APP界面设计简约，操作简单，使用不受时间、空间限制，只需一部可以上网的安卓系统手机即可，随时随地智能管控，方便快捷。</p><p><img src="http://files.xuruidea.com/0/20220711/微信截图_202207111830531657535469829.png" style="max-width:100%;" width="670.5" height="412.26" contenteditable="false"/></p><p><b>二、系统功能</b><br/></p><p style="text-align:left;">1&nbsp;、智慧水利APP，运用数字化、信息化、智能化手段提升水利管理效能，以闸泵远程控制、测流点监测、雨情、水位站、积水点、安防预警等功能模板为主，支持短信预警、报警记录、数据统计分析等功能；</p><p style="text-align:left;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p style="text-align:left;">2、可根据权限定时推送当日工作情况，自动分析汇总生成工作报表；并对各类关键指标，以动态图表、文字、仪表盘的形式直观展示，方便水利管理人员随时查看并处理，有效提升了行政效能，使水利管理工作更简单、便捷、高效。</p>',
          proSort: 9,
          proIsShow: 1,
          createTime: "2022-05-25 09:58:08",
          languageType: 1,
        },
      ],
      page: 0,
      softwareTabs: [
        {
          name: "智慧水利",
          imgURL: require("../assets/product/Water_affairs.jpg"),
          img: require("../assets/product/Water_affairs_HL.jpg"),
        },
        {
          name: "智慧城管",
          imgURL: require("../assets/product/Urban_management.jpg"),
          img: require("../assets/product/Urban_management_HL.jpg"),
        },
        {
          name: "智慧农业",
          imgURL: require("../assets/product/Agriculture.jpg"),
          img: require("../assets/product/Agriculture_HL.jpg"),
        },
      ],
      Sindex: 0,
      SprocessList: [
        {
          name: "前期沟通",
          icon: require("../assets/product/Early_communication.jpg"),
        },
        {
          name: "合同签订",
          icon: require("../assets/product/Contract_signing.jpg"),
        },
        {
          name: "需求分析",
          icon: require("../assets/product/requirement_analysis.jpg"),
        },
        {
          name: "原型设计",
          icon: require("../assets/product/Prototype_design.jpg"),
        },
        { name: "UI设计", icon: require("../assets/product/UI_design.jpg") },
        {
          name: "程序开发",
          icon: require("../assets/product/program_development.jpg"),
        },
        {
          name: "软件测试",
          icon: require("../assets/product/software_test.jpg"),
        },
        {
          name: "验收交付",
          icon: require("../assets/product/Acceptance_delivery.jpg"),
        },
      ],
      HprocessList: [
        {
          name: "产品设计",
          list: ["需求调研", "结构设计", "摸具设计", "包装设计", "外观设计"],
        },
        {
          name: "硬件设计",
          list: [
            "原理图设计",
            "射频天线设计",
            "样品制作",
            "电路板设计",
            "外观设计",
          ],
        },
        {
          name: "软件设计开发",
          list: [
            "交互设计",
            "APP前端开发",
            "嵌入式软件开发",
            "UML建模",
            "外观设计",
          ],
        },
        {
          name: "样品生产",
          list: ["", "需求调研", "产品包装", "组装生产", "模具制作"],
        },
        {
          name: "产品测试",
          list: ["", "集成测试", "性能测试", "硬件测试", "软件测试"],
        },
      ],
      HPindex: 4,
      show: true,
    };
  },
  created() {
    this.getHardwareData();
    this.getHardware();
    // console.log(this.$route.query.num - 1);
    // if (this.$route.query.num) {
    //   // this.TabsClick(this.$route.query.num - 1);
    // } else {
    //   this.TabsClick(0);
    // }
    // console.log(this.$route.query.id);
    // if (this.$router.query.id == "undefined") {
    // this.TabsClick(0);
    // }
    //  let data = {
    //     proType: 1,
    //   };
    //   this.$API.getSoftware(data).then((res) => {
    //     console.log("res :软件>> ", res);
    //     this.Software = res.data;
    //     // console.log(this.Software.proId);
    //     console.log(this.Software);
    //   });

    if (this.$route.query.id == 0) {
      this.TabsClick(0);
      // this.$route.query.name  = '#software'
      // this.returnTop1()
    }
    if (this.$route.query.id == 1) {
      this.TabsClick(1);
    }
    if (this.$route.query.id == 2) {
      // this.getSoftwareData(2);
      this.TabsClick(2);
      // this.getSoftwareData(3)
    }
    if (this.$route.query.id == 9) {
      // this.getSoftwareData(2);
      document.querySelector("#hardware").scrollIntoView(true);
      this.returnTop();
      // this.getSoftwareData(3)
    }
    if (this.$route.query.id == 11) {
      // this.getSoftwareData(2);
      document.querySelector("#software_customization").scrollIntoView(true);
      this.returnTop();
      // this.getSoftwareData(3)
    }
    if (this.$route.query.id == 12) {
      // this.getSoftwareData(2);
      document.querySelector("#hardware_customization").scrollIntoView(true);
      this.returnTop();
      // this.getSoftwareData(3)
    }
  },
  mounted() {
    
    // setInterval(window.addEventListener("scroll", this.handleScrollx, true), 0);
    window.addEventListener("scroll", this.handleScrollx, true);
    // 页面内点击锚点跳转
    if (this.$route.query.id == 0) {
      // this.TabsClick
      // this.$route.query.name  = '#software'
      this.returnTop1();
    }
    if (this.$route.query.id == 1) {
      // this.TabsClick
      // this.$route.query.name  = '#software'
      this.returnTop1();
    }
    if (this.$route.query.id == 2) {
      // this.TabsClick
      // this.$route.query.name  = '#software'
      this.returnTop1();
    }
    // 底部导航跳转
    if (this.$route.query.id == 9) {
      this.returnTop();
    }
    if (this.$route.query.id == 8) {
      this.returnTop1();
    }
    if (this.$route.query.id == 7) {
      this.returnTop2();
    }
    if (this.$route.query.id == 6) {
      this.returnTop3();
    }
    if (this.$route.query.id == 11) {
      // this.getSoftwareData(2);
      document.querySelector("#software_customization").scrollIntoView(true);

      // this.getSoftwareData(3)
    }
    if (this.$route.query.id == 12) {
      // this.getSoftwareData(2);
      document.querySelector("#hardware_customization").scrollIntoView(true);
      // this.getSoftwareData(3)
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx);
  },

  methods: {
    handleScrollx() {
      // console.log(
      //   "距离顶部高度",
      //   this.$refs.header.getBoundingClientRect().top
      // );
      // if (this.$refs.header.getBoundingClientRect().top < 200) {
      //   this.show = false;
      //   this.show1 = true;
      // }
      if (this.$refs.header.getBoundingClientRect().top < 200) {
        this.show = false;
        this.show1 = true;
      }
      if (this.$refs.header.getBoundingClientRect().top > 200) {
        this.show = true;
        this.show1 = false;
      }
    },
    // 硬件产品
    async getHardwareData() {
      let data = {
        // pageNum: 1,
        // pageSize: 4,

        pageNum: 1,
        pageSize: 4,
      };
      this.$API.getFenYeHardware(data).then((res) => {
        this.Hardware = res.data.list;
      });
    },
    // 软件产品
    async getSoftwareData(index) {
      let data = {
        // proType: index + 1,
        proType: index,
      };
      this.$API.getSoftware(data).then((res) => {
        console.log("res :软件>> ", res);
        this.Software = res.data;
        // console.log(this.Software.proId);
        console.log(this.Software);
      });
    },
    // 软件产品tabs
    TabsClick(index) {
      this.Sindex = index;
      console.log(this.Sindex, "选择的ID");
      this.getSoftwareData(index * 1 + 1);
      // this.$route.go(0)
    },
    processItemClick(index) {
      this.HPindex = index;
    },
    more(id) {
      this.$router.push({ path: "/productDetails", query: { id } });
    },
    prevClick() {
      if (this.RotationIndex > 0) {
        this.RotationIndex--;
      }
      this.RotationLeft = this.RotationIndex * -210;
      console.log(111);
    },
    nextClick() {
      let total = 7;
      let size = 5;
      if (this.RotationIndex < total % size) {
        this.RotationIndex++;
      }
      this.RotationLeft = this.RotationIndex * -210;
      // this.RotationLeft = -210;
      console.log(111);
    },
    prevClick1() {
      let data = {
        // pageNum: 1,
        // pageSize: 4,

        pageNum: 1,
        pageSize: 4,
      };
      this.$API.getFenYeHardware(data).then((res) => {
        this.Hardware = res.data.list;
      });
    },
    nextClick1() {
      let data = {
        // pageNum: 1,
        // pageSize: 4,

        pageNum: 2,
        pageSize: 4,
      };
      this.$API.getFenYeHardware(data).then((res) => {
        this.Hardware = res.data.list;
      });
    },
    gotoDetail(val) {
      console.log(val);
      let id = val.devId;
      this.$router.push({ path: `/HardwareDetail/${id}` });
    },
    // 软件水利详情
    gotoSoftware(item) {
      console.log(item);
      let id = item.proId;
      let type = 1;
      this.$router.push({
        path: `/SoftwareDetail/${id}/${type}`,
      });
    },
    // 软件城市详情
    gotoSoftware1(item) {
      console.log(item);
      let id = item.proId;
      let type = 1;
      this.$router.push({
        path: `/SoftwareDetail/${id}/${type}`,
      });
    },
    // 软件农业详情
    gotoSoftware2(item) {
      console.log(item);
      let id = item.proId;
      let type = 1;
      this.$router.push({
        path: `/SoftwareDetail/${id}/${type}`,
      });
    },
    gotoAbout() {
      this.$router.push({ path: "/about" });
    },
    gotoContact() {
      this.$router.push({ path: "/contact" });
    },
    // 硬件产品ALL
    getHardware() {
      let data = {};
      this.$API.getHardware(data).then((res) => {
        console.log("res :硬件产品列表>> ", res);
        this.HardwareList = res.data;
      });
    },
    gotoProduct() {
      //  this.show1 = true;
      console.log(111);
    },
    returnTop() {
      document.querySelector("#hardware").scrollIntoView(true);
    },
    returnTop1() {
      document.querySelector("#software").scrollIntoView(true);
    },
    returnTop2() {
      document.querySelector("#hardware_customization").scrollIntoView(true);
    },
    returnTop3() {
      document.querySelector("#software_customization").scrollIntoView(true);
    },
  },
  updated() {
    if (this.$route.query.name) {
      this.$el.querySelector(this.$route.query.name).scrollIntoView();
    }
  },
};
</script>
<style lang="less" scoped>
h2 {
  font-size: 38px;
  margin-left: 10px;
}
.isFixed {
  position: fixed;
  top: 0;
  background-color: yellow;
  z-index: 999;
}
.header1 {
  height: 240px;
  width: 1px;
}
.header-bg {
  font-size: 30px;
  background-color: red;
}

.content {
  width: 100%;
  background-color: #fff;
  .imgbox {
    width: 100%;
    height: 600px;
    position: relative;
    background-color: #004aa1;
    .banner_text {
      width: 60%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-40%, -60%);
      margin-top: -30px;
      span {
        margin: 30px 0;
        color: #fff;
      }
      span:nth-child(1) {
        // width: 100px;
        // height: 10px;
        background-color: #fff;
      }
      span:nth-child(2) {
        font-weight: 600;
        font-size: 50px;
      }
      span:nth-child(3) {
        font-weight: 600;
        font-size: 32px;
      }
      span:nth-child(4) {
        font-size: 22px;
      }
      button {
        cursor: pointer;
        width: 150px;
        height: 40px;
        border-radius: 25px;
        border: 1px solid #fff;
        color: #004aa1;
        font-weight: 600;
        font-size: 18px;
        margin-right: 30px;
      }
      button:hover {
        background-color: #004aa1;
        color: #fff;
      }
    }
  }
  .header {
    margin: auto;
    margin-top: 100px;
    // position: absolute;
    // bottom: -100px;
    // left: 50%;
    // transform: translate(-50%, -25%);
    // background-color: #fff;
    width: 60%;
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    .item {
      cursor: pointer;
      width: 25%;
      padding: 30px;
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      // border-right: 2px solid rgb(220, 220, 220);
      font-size: 18px;
      font-weight: 600;
      box-shadow: 0 0 2px 0 rgb(196, 196, 196);
      img {
        width: 40px;
        height: 40px;
      }
    }
    .item:nth-child(1) {
      // border-top-left-radius: 8px;
      // border-bottom-left-radius: 8px;
    }
    .item:nth-last-child(1) {
      // border: none;
      // border-top-right-radius: 8px;
      // border-bottom-right-radius: 8px;
    }
    .item:hover {
      background-color: rgb(235, 235, 235);
      color: #004aa1;
    }
  }
  .issFixed {
    position: fixed;
    top: -10px;
    left: -40px;
    right: 0;
    z-index: 1;
    // background-color: #fff();
    width: 40%;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0);
    // padding: 35px 0;

    .item {
      padding: 20px;
      height: 20px;
      width: 300px;
      // height: 100px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-radius: 500px;
      margin-right: 30px;
      // margin: auto;
      background-color: rgba(235, 235, 235, 0.9);
      //  background-color: #fff;
      span {
        font-size: 15px;
        color: #004aa1;
        font-weight: normal;
      }
      img {
        width: 20px;
      }

      item:hover {
        background-color: rgb(235, 235, 235);
      }
    }
  }

  .hardware,
  .software,
  .hardware_customization,
  .software_customization {
    margin: 0 auto;
    padding: 150px 15%;
    position: relative;
  }
  .software_customization {
    position: relative;
    .software_customization11 {
      position: absolute;
      top: 1px;
    }
  }
  .software {
    // height: 85vh;
  }
  .hardware {
    height: 140vh;
  }
  .hardware,
  .software {
    .title {
      display: flex;
      align-items: center;
      span:nth-child(1) {
        display: block;
        width: 8px;
        height: 32px;
        background: #004aa1;
      }
      span:nth-child(2) {
        font-size: 38px;
        font-weight: 600;
        margin-left: 10px;
      }
    }
  }
  .hardware_customization,
  .software_customization {
    .title {
      height: 240px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: #fff;
      padding: 30px;
      position: relative;
      padding-left: 260px;
      img {
        width: 220px;
        height: 300px;
        position: absolute;
        top: -70px;
        left: 20px;
      }
      p {
        margin-bottom: 25px;
      }
      p:nth-child(1) {
        font-size: 36px;
        font-weight: 600;
      }
      p:nth-child(2) {
        font-size: 22px;
      }
      p:nth-child(3) {
      }
      button {
        cursor: pointer;
        width: 140px;
        height: 40px;
        background-color: #fff;
        border-radius: 20px;
        border: 1px solid #fff;
        font-size: 16px;
        font-weight: 600;
        position: absolute;
        bottom: 20px;
        a {
            color: #004aa1;
        }
      }
      button:hover {
        background-color: #004aa1;
       a {
        color:#fff
       }
      }
    }
  }
  .hardware_customization {
    .title {
      background-image: url("../assets/product/customization_bg02.jpg");
    }
    .service_content {
      display: flex;
      justify-content: space-between;
      .left_img {
        width: 45%;
        img {
          width: 100%;
        }
      }
      .right_text {
        width: 50%;
        padding: 50px 10px;
        p:nth-child(1) {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .list {
          display: flex;
          justify-content: space-between;
          .left,
          .right {
            width: 45%;
            .item {
              display: flex;
              align-items: center;
              border-bottom: 1px dashed #999;
              padding: 10px 0;
              margin: 15px 0;
              span:nth-child(1) {
                display: block;
                background-color: #004aa1;
                color: #fff;
                border-radius: 50%;
                padding: 8px;
                font-weight: 600;
                font-size: 16px;
                margin-right: 10px;
              }
              span:nth-child(2) {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
    .service_process {
      .process_title {
        padding: 50px 0;
        span {
          font-size: 28px;
          font-weight: 600;
        }
      }
      .process_box {
        display: flex;
        position: relative;
        justify-content: space-around;
        height: 200px;
        .line {
          width: 100%;
          height: 4px;
          background-color: #999;
          position: absolute;
          top: 57%;
          span {
            display: block;
            width: 10%;
            height: 4px;
            background-color: #004aa1;
          }
        }
        .process_item {
          height: 160px;
          position: absolute;
          top: 0;
          .item_list {
            position: absolute;
            width: 200px;
            height: 100px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            padding: 0 10px;
            border-left: 1px dashed #004aa1;
            margin-left: 10px;
            opacity: 0;
            bottom: 60px;
          }
          .node {
            padding: 2px;
            border: 1px dashed #004aa1;
            border-radius: 50%;
            position: absolute;
            top: 65%;
            span {
              display: block;
              width: 15px;
              height: 15px;
              background-color: #004aa1;
              border-radius: 50%;
            }
          }
          .list {
            margin-top: 20px;
            position: absolute;
            top: 90%;
            left: -55px;
            span {
              display: block;
              width: 130px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              border: 1px solid #004aa1;
              border-radius: 20px;
              font-weight: 600;
              font-size: 17px;
            }
            span:hover {
              background-color: #004aa1;
              color: #fff;
            }
          }
          .active {
            span {
              background-color: #004aa1;
              color: #fff;
            }
          }
        }
        .process_item {
          position: relative;
        }
      }
    }
    .Networking {
      margin-top: 50px;
      .Networking_title {
        padding: 50px 0;
        span {
          font-size: 28px;
          font-weight: 600;
        }
      }
      .Rotation_box {
        position: relative;
        margin: 0 0 30px;
        height: 150px;

        .prev,
        .next {
          position: absolute;
          top: 34%;
          transform: translate(0%, -50%);
        }
        .prev {
          left: 0;
        }
        .next {
          right: 0;
        }
        .Rotation {
          width: 90%;
          height: 100px;
          margin: 0 auto;
          overflow: hidden;
          .list {
            position: relative;
            width: 100%;

            ul {
              display: flex;
              position: absolute;
              li {
                background-color: #fff;
                padding: 8px;
                img {
                  width: 134px;
                  height: 60px;
                  border: 1px solid #999;
                  padding: 10px;
                }
              }
            }
          }
        }
      }
    }
    .explain {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 222px;
      .left_text {
        .title1 {
          top: 1900px;
          position: absolute;
          margin-left: -30px;
        }
      }
      .left_text,
      .right_text {
        width: 44%;
        height: 180px;
        background-color: #004aa1;
        color: #fff;
        padding: 30px;
        border-radius: 8px;
        .left_title,
        .right_title {
          width: 100%;
          display: flex;
          align-items: center;
          img {
            width: 36px;
            height: 36px;
            margin-right: 10px;
          }
          span {
            font-size: 28px;
            font-weight: 600;
          }
        }
        .item {
          margin-top: 10px;
          height: 35px;
          line-height: 35px;
          border-bottom: 1px dashed rgba(255, 255, 255, 0.438);
          span {
            font-size: 17px;
            margin-right: 5px;
          }
          span:nth-child(1),
          span:nth-child(2) {
            font-weight: 600;
          }
        }
        p {
          margin-top: 20px;
          line-height: 30px;
          font-size: 17px;
        }
      }
    }
  }
  .software_customization {
    .title {
      background-image: url("../assets/product/customization_bg01.jpg");
    }
    .service_content {
      display: flex;
      justify-content: space-between;
      .left_img {
        width: 45%;
        img {
          width: 100%;
        }
      }
      .right_text {
        width: 50%;
        padding: 50px 10px;
        p:nth-child(1) {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .list {
          display: flex;
          justify-content: space-between;
          width: 100%;
          .item {
            display: flex;
            align-items: center;
            border-bottom: 1px dashed #999;
            padding: 10px 0;
            margin: 15px 0;
            span:nth-child(1) {
              display: block;
              background-color: #004aa1;
              color: #fff;
              border-radius: 50%;
              padding: 8px;
              font-weight: 600;
              font-size: 16px;
              margin-right: 10px;
            }
            span:nth-child(2) {
              font-size: 18px;
              font-weight: 600;
              margin-right: 10px;
            }
          }
        }
      }
    }
    .service_process {
      .process_title {
        padding: 50px 0;
        span {
          font-size: 28px;
          font-weight: 600;
        }
      }
      .process_box {
        display: flex;
        position: relative;
        justify-content: space-around;
        height: 300px;
        .line {
          width: 100%;
          border-bottom: 1px dashed #999;
          position: absolute;
          top: 60%;
        }
        .process_item {
          height: 220px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          img {
            width: 130px;
          }
          span {
            font-weight: 600;
            font-size: 18px;
          }
          .node {
            padding: 2px;
            border: 1px dashed #004aa1;
            border-radius: 50%;
            margin-left: -5px;
            span {
              display: block;
              width: 15px;
              height: 15px;
              background-color: #004aa1;
              border-radius: 50%;
            }
          }
        }
        .process_item:nth-child(2n) {
          position: relative;
          top: 12px;
        }
        .process_item:nth-child(2n + 1) {
          position: relative;
          top: 130px;
          display: flex;
          flex-direction: column-reverse;
        }
      }
    }
    .advantage {
      margin-top: 50px;
      padding-bottom: 100px;
      .advantage_title {
        padding: 50px 0;
        span {
          font-size: 28px;
          font-weight: 600;
        }
      }
      .advantage_content {
        display: flex;
        justify-content: space-between;
        position: relative;
        .left_text {
          z-index: 1;
          .advantage_item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            span {
              display: block;
              width: 5px;
              height: 50px;
              background-color: #004aa1;
              margin-right: 15px;
            }
            .text {
              line-height: 30px;
              p {
                font-size: 18px;
              }
              p:nth-child(1) {
                font-weight: 600;
                color: #004aa1;
              }
              p:nth-child(2) {
                font-size: 17px;
              }
            }
          }
        }
        .right_img {
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate(0%, -50%);
          z-index: 0;
          img {
            width: 550px;
          }
        }
      }
    }
  }
  .hardware {
    width: 60%;
    .infor_data {
      .Rotation_box {
        width: 100%;
        overflow: hidden;
        position: relative;
        padding: 50px;
        .prev,
        .next {
          position: absolute;
          top: 40%;
        }
        .prev {
          left: 0;
        }
        .next {
          right: 0;
        }
        .list {
          width: 100%;
          display: flex;
          justify-content: center;
          padding: 10px;
          flex-wrap: wrap;
          .item {
            width: 23%;
            margin: 1% 1%;
            height: 400px;
            background-color: #004aa1;
            border-radius: 10px;
            box-shadow: 0 0 10px 2px rgb(210, 210, 210);

            .devImg {
              width: 100%;
              height: 300px;
              // border-radius: 8px;
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
              background-color: #fff;
              img {
                width: 100%;
                height: 100%;
                border-radius: 8px;
              }
            }

            .text {
              width: 100%;
              height: 100px;
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
              align-items: center;
              color: #fff;
              text-align: center;
              p {
                font-size: 18px;
                font-weight: 600;
              }
              span {
                cursor: pointer;
                display: block;
                padding: 5px 40px;
                border: 1px solid #fff;
                border-radius: 20px;
              }
              span:hover {
                background-color: #fff;
                color: #004aa1;
              }
            }
          }
        }
      }
    }
  }
  .software {
    background-image: url("../assets/product/software_bg.jpg");
    color: #fff;
    padding-bottom: 150px;
    .title {
      span:nth-child(1) {
        background: #fff;
      }
      span:nth-child(2) {
      }
    }
    .infor_data {
      margin-top: 50px;
      .tabs {
        display: flex;
        justify-content: center;
        .tabs_item {
          width: 33.3%;
          padding: 15px 0;
          background-color: #fff;
          color: #004aa1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          img {
            width: 50px;
          }
          p {
            font-weight: 600;
            font-size: 18px;
          }
        }
        .active {
          background-color: #004aa1;
          color: #fff;
        }
        .tabs_item:nth-child(1) {
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
        .tabs_item:nth-last-child(1) {
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }
      }
      .tabs_content {
        margin-top: 10px;
        // height: 400px;
        border-radius: 8px;
        padding: 30px;
        background-color: #fff;
        .item_content {
          display: flex;
          flex-wrap: wrap;
          .item {
            width: 20%;
            height: 170px;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            span {
              color: #000;
            }
            img {
              width: 100px;
              height: 100px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
